document.addEventListener("alpine:init", () => {
  Alpine.store("wishlist", {
    value: Alpine.$persist([]).as('shopify-wishlist'),
    customerName: null,
    customerId: null,
    wishlistMetafield: null,
    isLoggedIn: false,
    init() {
      let el = document.querySelector("#customer-data");
      if (el) {
        let customer = JSON.parse(el.text);
        this.customerName = customer.firstName;
        this.customerId = customer.id;
        this.wishlistMetafield = customer.wishlist;
        this.isLoggedIn = true;
      }      
      else {
        this.isLoggedIn = false;
      }
      this.sync([]);
    },
    add(productId, handle) {
      if (this.value.some(x => x.productId == productId)) return;

      let dateAdded = new Date().toISOString();
      let wishlistItem = {
        handle: handle,
        productId: productId.toString(),
        dateAdded: dateAdded,
        syncNeeded: true
      };
      this.value.unshift(wishlistItem);
      if (this.value.length > 100) {
        this.value = this.value.slice(0, 100);
      }
      this.sync([]);
    },
    remove(productId) {
      let index = this.value.findIndex(x => x.productId == productId.toString());
      if (index >=0 ) this.value.splice(index, 1);
      this.sync([{
        productId: productId,
        quantity: 0
      }]);
    },

    removeMultiple(productIds) {
      // Ensure productIds is an array (handles single ID or array input)
      const ids = Array.isArray(productIds) ? productIds : [productIds];

      // Remove each product from the local value array
      ids.forEach(id => {
        let index = this.value.findIndex(x => x.productId == id.toString());
        if (index >= 0) {
          this.value.splice(index, 1);
        }
      });

      // Sync the changes (set quantity to 0 for all removed IDs)
      this.sync(ids.map(id => ({
        productId: id,
        quantity: 0
      })));
    },

    clear() {
      let remove = this.value.map(x => ({
        productId: x.productId,
        quantity: 0
      }));
      this.value = [];
      this.sync(remove);
    },
    includesProductId(productId) {
      return this.value.some(x => x.productId == productId.toString());
    },
    get length() {
      return this.value.length;
    },
    syncNeeded() {
      if (!this.isLoggedIn) return false;
      if (this.wishlistMetafield == null) return true;
      if (this.wishlistMetafield.length != this.value.length) return true;
      for (let i = 0; i < this.wishlistMetafield.length; i++) {
        let handle = this.wishlistMetafield[i];
        if (handle != this.value[i].handle) return true;
      }
      return false;
    },
    sync(removed, baseList = null) {
      if (!this.syncNeeded()) return;
      let payload = this.value.filter(x => x.syncNeeded).map(x => ({ ...x, customerName: this.customerName, quantity: 1 })).concat(removed);
      let f = fetch(`https://thecubicle-7879130294-webhooks.azurewebsites.net/wishlists/${this.customerId}/sync`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload)
      }).then((res) => res.json())
        .then((res) => {
          this.value = res.map(x => ({
            productId: x.productId.toString(),
            handle: x.handle,
            dateAdded: x.dateAdded
          }));
          this.wishlistMetafield = this.value.map(x => x.handle);
        });

    },
  });
  
  Alpine.data("wishlistButton", (productId, handle) => ({
    productId: productId,
    handle: handle,
    isWishlisted() {
      return this.$store.wishlist.includesProductId(this.productId);
    },
    onWishlistButtonClick() {
      if (this.isWishlisted()) {
        this.$store.wishlist.remove(this.productId);
        if (this.myWishlist?.productCardHideList) {
          this.myWishlist.productCardHideList.push(this.productId);
        }
        
      }
      else {
        this.$store.wishlist.add(this.productId, this.handle);
      }    
    }
  }));

   Alpine.data("myWishlist", () => ({
     myWishlist: {
      grid: null,
      loading: false,
      url: null,
      customerId: null,
      productCardHideList: [],       
     },
      async init() {
        this.myWishlist.loading = true;
        this.myWishlist.customerId = this.$store.customer.id;
        if (this.myWishlist.customerId) {
          let data = JSON.parse(this.$refs.data.text);
          this.myWishlist.url = data.url;
        }
        const requests = this.$store.wishlist.value.map(x => fetchProductCard(x.handle, x.productId, "my-wishlist"));
        const responses = await Promise.all(requests);
        const delistedProducts = responses.filter(x => !x.html);
        if (delistedProducts.length) {
          this.$store.wishlist.removeMultiple(delistedProducts.map(x => x.productId));
        }
        const wishlistProductCards = responses.map(x => x.html).join("");
        this.myWishlist.grid = wishlistProductCards;
        this.myWishlist.loading = false;
      },
     copyUrl() {
        navigator.clipboard.writeText(this.myWishlist.url);
        this.$refs.tooltip.classList.add('opacity-100');
        setTimeout(() => {
            this.$refs.tooltip.classList.remove('opacity-100');
        }, 2000);        
     },
     clearWishlist() {
       if (!confirm('Are you sure you want to clear your wishlist?')) return;
       let allProducts = this.$store.wishlist.value.map(x => Number(x.productId));
       this.$store.wishlist.clear();
       this.myWishlist.productCardHideList = this.myWishlist.productCardHideList.concat(allProducts);
     }
  }));

  Alpine.data("publicWishlist", () => ({
    publicWishlist: {
      grid: null,
      loading: false,
      customerId: null,
      emtpy: false
    },
      async init() {
        this.publicWishlist.loading = true;
        let customerId = this.$store.queryParams.get('id');
        const url = "https://thecubicle-7879130294-webhooks.azurewebsites.net/wishlists?customerId=" + customerId;
        let res = await fetch(url);
        let data = await res.json();
        if (data.length == 0) {
          this.publicWishlist.empty = true;
          this.publicWishlist.loading = false;
          return;
        }
        const requests = data.map(x => fetchProductCard(x.handle, x.productId, "public-wishlist"));
        const responses = await Promise.all(requests);
        const wishlistProductCards = responses.map(x => x.html).join("");
        this.publicWishlist.grid = wishlistProductCards;
        this.publicWishlist.loading = false;
        // grid.innerHTML = wishlistProductCards;
      },
     clearWishlist() {
       let allProducts = this.$store.wishlist.value.map(x => Number(x.productId));
       this.$store.wishlist.clear();
       this.productCardHideList = allProducts;
     }
  }));
  
});
